import {StyledCalendarPickerWeekday} from '@/components/commons/calendar/week-day/style'
import {Text} from '@/components/ui/text/Text'
import {WeekdayProps} from 'react-day-picker'

export const Weekday = (props: WeekdayProps) => {
    return (
        <StyledCalendarPickerWeekday {...props}>
            <Text render="span" size="textSm" palette="neutral" shade="500">
                {props.children?.toString().charAt(0)}
            </Text>
        </StyledCalendarPickerWeekday>
    )
}
